//#region Styles
import { Column, Row } from "components/styles";
//#endregion
//#region Components
import CustomDatePicker from "components/CustomDatePicker/CustomDatePicker";
import CustomSelect from "components/CustomSelect/CustomSelect";
import CustomButton from "components/CustomButton/CustomButton";
//#endregion
//#region Icons
import ClearIcon from "icons/ClearIcon";
import SearchIcon from "icons/SearchIcon";
//#endregion
//#region Services
//#endregion
//#region Utils
import { getOptionsToCustomSelect } from "components/CustomSelect/utils";
import useChangeLibraryListByCampus from "views/Recursos/ResourcesLibrary/utils/hooks/useChangeLibraryListByCampus";
import { FILTER_STYLE_PROPS } from "views/Recursos/ResourcesLibrary/utils/constants";
import useLibrarianCampus from "views/Recursos/ResourcesLibrary/utils/hooks/useLibrarianCampus";
//#endregion

const Filters = ({
    loadingRequest,
    isLibrarian, filters,
    data: {
        campusList,
        libraryList, 
        resourceTypes
    }, header,
    allFilterFieldsWereFilled,
    resetUI, triggerServiceFilling
}) => {
    //#region Functions
    const changeLibraryField = value => {
        filters.change("libraryId", value);
    }
    const changeResourceTypeId = value => {
        filters.change("resourceTypeId", value);
    }
    const changeCampusField = value => {
        filters.change("campusId", value);
    }
    const changeDate = value => {
        filters.change("date", value);
    }
    const applyFilters = () => {
        triggerServiceFilling();
    }
    //#endregion
    const filtersFieldsIsCleared = filters.isCleared();
    const { libraryListByCampus } = useChangeLibraryListByCampus({
        campusId: filters.value.campusId,
        changeLibraryField,
        libraryList
    });
    useLibrarianCampus({
        changeFilter: filters.change,
        isLibrarian
    });
    return (
        <Column marginTop="20px">
            {header}
            <Row width="100%" justifyContent="flex-start" align="flex-end">
                <Row justifyContent="flex-start" align="flex-end">
                    <CustomSelect 
                        {...FILTER_STYLE_PROPS.CUSTOM_SELECT}
                        label="Campus"
                        value={filters.value.campusId}
                        optionsProps={getOptionsToCustomSelect(campusList, { id: "id", text: "name" })}
                        onChange={changeCampusField}
                        disabled={isLibrarian}
                        defaultOptionText="Elige un Campus"/>
                    <CustomSelect 
                        {...FILTER_STYLE_PROPS.CUSTOM_SELECT}
                        label="Biblioteca"
                        value={filters.value.libraryId}
                        optionsProps={getOptionsToCustomSelect(libraryListByCampus, { id: "id", text: "name" })}
                        onChange={changeLibraryField}
                        defaultOptionText="Elige una Biblioteca"
                        disabled={libraryListByCampus.length === 0}/>
                    <CustomSelect 
                        {...FILTER_STYLE_PROPS.CUSTOM_SELECT}
                        label="Recurso"
                        value={filters.value.resourceTypeId}
                        optionsProps={getOptionsToCustomSelect(resourceTypes, { id: "id", text: "name" })}
                        onChange={changeResourceTypeId}
                        defaultOptionText="Elige un Recurso"/>
                    <CustomDatePicker 
                        label="Fecha"
                        value={filters.value.date}
                        onChange={changeDate}
                        period={{
                            min: [2022, 1, 1],
                            max: [3000, 1, 1]
                        }}/>
                </Row>
                <Row>
                    <CustomButton 
                        {...FILTER_STYLE_PROPS.CUSTOM_BUTTON}
                        onClick={applyFilters}
                        icon={<SearchIcon/>}
                        text="Aplicar"
                        width="100px"
                        disabled={!allFilterFieldsWereFilled}/>
                    <CustomButton 
                        {...FILTER_STYLE_PROPS.CUSTOM_BUTTON}
                        disabled= {filtersFieldsIsCleared}
                        onClick={resetUI}
                        variant={filtersFieldsIsCleared ? "primary" : "secondary"}
                        icon={<ClearIcon/>}
                        text="Limpiar"/>
                </Row>
            </Row>
        </Column>
    );
}

export default Filters;